import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { PdpEcolodgePoliciesDialogComponent } from '../pdp-ecolodge-policies-dialog/pdp-ecolodge-policies-dialog.component';
import { CancellationPlanEnum } from '../pdp-ecolodge.model';



@Component({
    selector: 'iho-pdp-ecolodge-policies',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './pdp-ecolodge-policies.component.html',
    styleUrls: ['./pdp-ecolodge-policies.component.scss'],
})
export class PdpEcolodgePoliciesComponent {
    @Input() set dataSource(value: any) {
        this.hotel = value;
    }
    hotel: any;
    cancellationPlanEnum = CancellationPlanEnum

    constructor(
        private dialog: MatDialog
    ){
    }

    showModal() {
        this.dialog.open(PdpEcolodgePoliciesDialogComponent, {
            panelClass: [
                'custom-modal',
                'ecolodge-policies-modal',
                'w-screen',
                'lg:w-[600px]',
                'h-screen',
                '!max-w-full',
                'lg:h-[50%]',
            ],
            data: this.hotel.Rules.CancellationPlan,
            autoFocus: false
        })
    }

    get checkIn() {
        let text = ''
        if (this.hotel.Rules.MaxCheckinTime) {
            if (this.hotel.Rules.MaxCheckinTime == this.hotel.Rules.Checkin || this.hotel.Rules.MaxCheckinTime == '00:00') {
                text = `از ${this.hotel.Rules.Checkin}`
            } else {
                text = `${this.hotel.Rules.Checkin} الی ${this.hotel.Rules.MaxCheckinTime}`
            }
        } else {
            text = `از ${this.hotel.Rules.Checkin}`
        }
        return text
    }

    get checkOut() {
        let text = ''
        if (this.hotel.Rules.MaxCheckoutTime) {
            if (this.hotel.Rules.MaxCheckoutTime == this.hotel.Rules.Checkout || this.hotel.Rules.MaxCheckoutTime == '00:00') {
                text = `تا ${this.hotel.Rules.Checkout}`
            } else {
                text = `${this.hotel.Rules.Checkout} الی ${this.hotel.Rules.MaxCheckoutTime}`
            }
        } else {
            text = `تا ${this.hotel.Rules.Checkout}`
        }
        return text
    }

}
